<template>
  <basic-container class="property-charge">
    <!-- <el-button @click="test">ceso</el-button> -->
    <div>
      <div class="title">住户信息</div>
      <el-divider></el-divider>
      <el-form label-width="80px">
        <el-row>
          <el-col :span="4">
            <!-- communityGroupList -->
            <el-form-item label="小区分组">
              <el-select style="width: 100%" v-model="communityGroup" @change="communityGroupChangeHandler">
                <el-option
                  v-for="item in communityGroupList"
                  :key="item"
                  :value="item.dictKey"
                  :label="item.dictValue"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="速记号">
              <el-autocomplete
                v-model="zhxx.shortCode"
                :trigger-on-focus="false"
                placeholder="请至少输入3个字符"
                :debounce="1000"
                :fetch-suggestions="queryShortCode"
                @select="selectShortCode"
              ></el-autocomplete>
            </el-form-item> -->
          </el-col>
          <el-col :span="8">
            <el-form-item label="房产">
              <el-input v-model="zhxx.roomName" readonly @focus="showRoomSelect = true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="房型">
              <el-input v-model="zhxx.roomLayoutName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="房屋类型">
              <el-input v-model="zhxx.roomTypeName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label-width="32px">
              <el-radio
                v-if="zhxx.additionAreaFlag === 1"
                v-model="zhxx.additionAreaFlag"
                :label="1"
                >有加建</el-radio
              >
              <el-radio v-else v-model="zhxx.additionAreaFlag" :label="1" disabled>无加建</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <el-form-item label="房屋状态">
              <el-input v-model="zhxx.roomStatusName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="建筑面积">
              <el-input v-model="zhxx.floorage" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="使用面积">
              <el-input v-model="zhxx.usableArea" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="朝向">
              <el-input v-model="zhxx.roomOrientations" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="是否启用">
              <el-select v-model="zhxx.useFlag" placeholder disabled>
                <el-option label="是" :value="1"></el-option>
                <el-option label="否" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label-width="32px">
              <el-radio v-if="zhxx.parkingAreaFlag === 1" v-model="zhxx.parkingAreaFlag" :label="1"
                >有车库</el-radio
              >
              <el-radio v-else v-model="zhxx.parkingAreaFlag" :label="1" disabled>无车库</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <el-form-item label="户主">
              <el-input v-model="zhxx.householder" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="联系方式">
              <el-input v-model="zhxx.householderPhone" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="租户">
              <el-input v-model="zhxx.leaseholder" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="联系方式">
              <el-input v-model="zhxx.leaseholderPhone" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4"></el-col>
          <el-col :span="4">
            <el-form-item label-width="32px">
              <el-radio v-if="zhxx.loftAreaFlag === 1" v-model="zhxx.loftAreaFlag" :label="1"
                >有阁楼</el-radio
              >
              <el-radio v-else v-model="zhxx.loftAreaFlag" :label="1" disabled>无阁楼</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <el-form-item label="车辆1">
              <el-input
                v-model="zhxx.carNo1"
                disabled
                :class="{
                  danger: zhxx.carStatus1 === 0,
                  warning: zhxx.carStatus1 === 1,
                }"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="车辆2">
              <el-input
                v-model="zhxx.carNo2"
                disabled
                :class="{
                  danger: zhxx.carStatus2 === 0,
                  warning: zhxx.carStatus2 === 1,
                }"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div>
      <div class="title">欠费信息</div>
      <el-divider></el-divider>
      <el-form label-width="100px">
        <el-row>
          <el-col :span="5">
            <el-form-item label="当前欠费(元)">
              <el-input
                v-model="qfxx.totalAmount"
                disabled
                :class="{
                  danger: qfxx.totalAmount !== 0,
                }"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="物业费(元)">
              <el-input
                v-model="qfxx.propertyAmount"
                disabled
                :class="{
                  danger: qfxx.propertyAmount !== 0,
                }"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="其他自收费(元)" label-width="120px">
              <el-input
                v-model="qfxx.otherAmount"
                disabled
                :class="{
                  danger: qfxx.otherAmount !== 0,
                }"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="代收费(元)">
              <el-input
                v-model="qfxx.proxyAmount"
                disabled
                :class="{
                  danger: qfxx.proxyAmount !== 0,
                }"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-tabs v-model="activeTab">
        <el-tab-pane name="1">
          <span slot="label">
            <i v-show="selected.billPay" class="el-icon-s-flag" style="color: #f56c6c"></i>
            账单收费
          </span>
          <el-row>
            <el-col :span="20">
              <el-form label-width="100px" :disabled="selected.billPay">
                <el-row>
                  <el-col :span="14">
                    <el-form-item label-width="40px">
                      <el-checkbox
                        v-model="billPay2.propertyAmountCheck"
                        v-if="permissions.propertyAmountCheck"
                        :true-label="1"
                        :false-label="0"
                        @change="queryBill"
                        >物业费</el-checkbox
                      >
                      <el-checkbox
                        v-model="billPay2.otherAmountCheck"
                        v-if="permissions.otherAmountCheck"
                        :true-label="1"
                        :false-label="0"
                        @change="queryBill"
                        >其他自收费</el-checkbox
                      >
                      <el-checkbox
                        v-model="billPay2.proxyAmountCheck"
                        v-if="permissions.proxyAmountCheck"
                        :true-label="1"
                        :false-label="0"
                        @change="queryBill"
                        >代收费</el-checkbox
                      >
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="金额小计(元)">
                      <el-input
                        v-model="billPay.sumOfAmount"
                        :class="{
                          danger: billPay.sumOfAmount !== 0,
                        }"
                        disabled
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </el-col>
            <el-col :span="4">
              <div style="padding-left: 32px">
                <el-button
                  type="primary"
                  :disabled="isSuccess || selected.billPay"
                  @click="confirmBillPay"
                  >选中</el-button
                >
                <el-button type="danger" :disabled="isSuccess" @click="cancelBillPay"
                  >取消</el-button
                >
              </div>
            </el-col>
          </el-row>
          <el-table
            :data="billPay2.list"
            stripe
            border
            style="width: 100%; margin-bottom: 26px; max-height: 420px; overflow: scroll"
            @selection-change="onBillSelectionChange"
          >
            <el-table-column
              type="selection"
              width="55"
              :selectable="setBillTableSelect"
            ></el-table-column>
            <el-table-column
              prop="billFeeItemName"
              label="费用名称"
              width="250px"
            ></el-table-column>
            <el-table-column
              prop="billcycleNo"
              label="账单周期编码"
              width="120px"
            ></el-table-column>
            <el-table-column
              prop="billStartDate"
              label="账单开始时间"
              width="130px"
            ></el-table-column>
            <el-table-column
              prop="billEndDate"
              label="账单结束时间"
              width="130px"
            ></el-table-column>
            <!--1. 划扣中(不能选) 0. 未锁定(可以选)-->
            <el-table-column prop="calAmount" label="理论金额"></el-table-column>
            <el-table-column prop="delayAmount" label="滞纳金"></el-table-column>
            <el-table-column prop="billPreferentAmount" label="政策优惠"></el-table-column>
            <el-table-column prop="billCouponAmount" label="优惠券抵扣">
              <template slot-scope="sp">
                <div v-if="sp.row.billCouponFlag === 0">{{ sp.row.billCouponAmount }}</div>
                <el-input
                  v-else
                  v-model="sp.row.billCouponAmount"
                  @blur="updateBill(sp.row)"
                  @keyup.enter.native="updateBill(sp.row)"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="billShouldAmount" label="应收金额"></el-table-column>

            <el-table-column label="划扣账单状态">
              <template slot-scope="sp">
                <div>{{ getLockFlagStatus(sp.row.lockFlag) }}</div>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane name="2">
          <span slot="label">
            <i v-show="selected.prePay" class="el-icon-s-flag" style="color: #f56c6c"></i>
            费用预收
          </span>
          <el-row>
            <el-col :span="20">
              <el-form
                label-width="100px"
                ref="prePay"
                :rules="prePayRules"
                :model="prePay"
                :disabled="selected.prePay"
              >
                <el-row>
                  <el-col :span="6">
                    <el-form-item label="费项" prop="itemsetId">
                      <el-select
                        v-model="prePay.itemsetId"
                        placeholder="请选择"
                        @change="selectPrePayItem"
                      >
                        <el-option
                          v-for="item in prePay2.itemList"
                          :key="item.itemsetId"
                          :label="item.advanceFeeItemName"
                          :value="item.itemsetId"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5">
                    <el-form-item label="开始周期" label-width="80px">
                      <el-select
                        v-model="prePay.billcycleNo"
                        placeholder="请选择"
                        @change="selectBillcycleNo"
                      >
                        <el-option
                          v-for="item in prePay2.billStartDateList"
                          :key="item.billcycleNo"
                          :label="item.billcycleNo"
                          :value="item.billcycleNo"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5">
                    <el-form-item label="期数" prop="cycleNum">
                      <el-input
                        v-model="prePay.cycleNum"
                        :disabled="vdui.isEmpty(prePay.itemsetId)"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label-width="14px">
                      <el-input v-model="prePay.billStartDate" disabled></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="~" label-width="14px">
                      <el-input v-model="prePay.billEndDate" disabled></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <el-form-item label="优惠政策">
                      <el-input v-model="prePay2.preferentName" disabled></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="6">
                    <el-form-item label="费用总额(元)">
                      <el-input v-model="prePay.calAmount" disabled></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="政策优惠(元)">
                      <el-input v-model="prePay.derateAmount" disabled></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="优惠券抵扣(元)" label-width="120px" prop="couponAmount">
                      <el-input
                        v-model="prePay.couponAmount"
                        :disabled="prePay2.couponFlag === 0 || !prePay.calAmount"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="应收金额(元)">
                      <el-input v-model="prePay.shouldAmount" disabled></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </el-col>
            <el-col :span="4">
              <div style="padding-left: 32px">
                <el-button
                  type="primary"
                  :disabled="isSuccess || selected.prePay"
                  @click="confirmPrePay"
                  >选中</el-button
                >
                <el-button type="danger" :disabled="isSuccess" @click="cancelPrePay"
                  >取消</el-button
                >
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
<!--        <el-tab-pane name="3">-->
<!--          <span slot="label">-->
<!--            <i v-show="selected.carPay" class="el-icon-s-flag" style="color: #f56c6c"></i>-->
<!--            车辆收费-->
<!--          </span>-->
<!--          <el-row>-->
<!--            <el-col :span="20">-->
<!--              <el-form-->
<!--                label-width="80px"-->
<!--                ref="carPay"-->
<!--                :rules="carPayRules"-->
<!--                :model="carPay"-->
<!--                :disabled="selected.carPay"-->
<!--              >-->
<!--                <el-row>-->
<!--                  <el-col :span="6">-->
<!--                    <el-form-item label="停车场" label-width="72px" prop="communityId">-->
<!--                      <el-select-->
<!--                        v-model="carPay.communityId"-->
<!--                        filterable-->
<!--                        remote-->
<!--                        :remote-method="queryCarPayPark"-->
<!--                        @change="selectCarPayPark"-->
<!--                      >-->
<!--                        <el-option-->
<!--                          v-for="item in carPay2.parkList"-->
<!--                          :key="item.communityId"-->
<!--                          :label="item.communityName"-->
<!--                          :value="item.communityId"-->
<!--                        ></el-option>-->
<!--                      </el-select>-->
<!--                    </el-form-item>-->
<!--                  </el-col>-->
<!--                  <el-col :span="5">-->
<!--                    <el-form-item label="车牌号" label-width="72px" prop="carNo" @click="test">-->
<!--                      <avue-input-tree-->
<!--                        ref="carNoInputTree"-->
<!--                        @change="onInputFocusHandler"-->
<!--                        @blur="onInputFocusHandler"-->
<!--                        default-expand-all-->
<!--                        v-model="carPay.carNo"-->
<!--                        placeholder="请选择内容"-->
<!--                        type="tree"-->
<!--                        :dic="carNoList"-->
<!--                      >-->
<!--                      </avue-input-tree>-->
<!--                      &lt;!&ndash;-->
<!--                      <el-autocomplete-->
<!--                        v-model="carPay.carNo"-->
<!--                        :debounce="1000"-->
<!--                        :trigger-on-focus="true"-->
<!--                        :disabled="vdui.isEmpty(carPay.communityId)"-->
<!--                        :fetch-suggestions="queryCarPayMonthCarNo"-->
<!--                        @select="selectCarPayCarNo"-->
<!--                        @blur="selectCarPayCarNo_Blur"-->
<!--                      ></el-autocomplete>-->
<!--                       &ndash;&gt;-->
<!--                      &lt;!&ndash; :trigger-on-focus="false" &ndash;&gt;-->
<!--                      &lt;!&ndash; @select="selectCarPayCarNo" &ndash;&gt;-->
<!--                    </el-form-item>-->
<!--                  </el-col>-->
<!--                  <el-col :span="5">-->
<!--                    <el-form-item label="欠费金额">-->
<!--                      <el-input-->
<!--                        v-if="!carPay.backAmount"-->
<!--                        v-model="carPay.backAmount"-->
<!--                        disabled-->
<!--                      ></el-input>-->
<!--                      <el-popover v-else width="500" trigger="click">-->
<!--                        <el-table :data="carPay2.billList">-->
<!--                          <el-table-column-->
<!--                            width="80"-->
<!--                            property="carNo"-->
<!--                            label="车牌号"-->
<!--                          ></el-table-column>-->
<!--                          <el-table-column-->
<!--                            width="80"-->
<!--                            property="payableMoney"-->
<!--                            label="欠费金额"-->
<!--                          ></el-table-column>-->
<!--                          <el-table-column-->
<!--                            width="80"-->
<!--                            property="parkTime"-->
<!--                            label="停车时长（时）"-->
<!--                          ></el-table-column>-->
<!--                          <el-table-column-->
<!--                            width="130"-->
<!--                            property="inTime"-->
<!--                            label="进场时间"-->
<!--                          ></el-table-column>-->
<!--                          <el-table-column-->
<!--                            width="130"-->
<!--                            property="outTime"-->
<!--                            label="出场时间"-->
<!--                          ></el-table-column>-->
<!--                        </el-table>-->
<!--                        <el-input-->
<!--                          v-model="carPay.backAmount"-->
<!--                          disabled-->
<!--                          slot="reference"-->
<!--                          class="danger"-->
<!--                          @click.native="queryCarPayBill"-->
<!--                        >-->
<!--                          <i slot="suffix" class="el-input__icon el-icon-search"></i>-->
<!--                        </el-input>-->
<!--                      </el-popover>-->
<!--                    </el-form-item>-->
<!--                  </el-col>-->
<!--                  <el-col :span="8">-->
<!--                    <el-form-item label="补缴方式">-->
<!--                      <el-radio-group-->
<!--                        v-model="carPay.backType"-->
<!--                        :disabled="!carPay.communityId || !carPay.carNo"-->
<!--                      >-->
<!--                        <el-radio v-if="permissions.byMonthCar" :label="1">&nbsp;以月卡车</el-radio>-->
<!--                        <el-radio v-if="permissions.byTempCar" :label="2">&nbsp;以临停车</el-radio>-->
<!--                        <el-radio v-if="permissions.byNoSubsidy" :label="3">&nbsp;不补</el-radio>-->
<!--                      </el-radio-group>-->
<!--                    </el-form-item>-->
<!--                  </el-col>-->
<!--                </el-row>-->
<!--                <el-row>-->
<!--                  <el-col :span="6">-->
<!--                    <el-form-item label="开始时间" prop="startTime">-->
<!--                      <el-date-picker-->
<!--                        v-model="carPay.startTime"-->
<!--                        type="date"-->
<!--                        placeholder="选择日期"-->
<!--                        value-format="yyyy-MM-dd"-->
<!--                        :disabled="carPay.backType === 1"-->
<!--                      ></el-date-picker>-->
<!--                    </el-form-item>-->
<!--                  </el-col>-->
<!--                  <el-col :span="4">-->
<!--                    <el-form-item label="套餐周期" prop="cycleNum">-->
<!--                      <el-select-->
<!--                        v-model="carPay.cycleNum"-->
<!--                        filterable-->
<!--                        placeholder="请选择"-->
<!--                        :disabled="!carPay.carNo"-->
<!--                      >-->
<!--                        <el-option-->
<!--                          v-for="item in carPay2.monthList"-->
<!--                          :key="item.value"-->
<!--                          :label="item.label"-->
<!--                          :value="item.value"-->
<!--                        ></el-option>-->
<!--                      </el-select>-->
<!--                    </el-form-item>-->
<!--                  </el-col>-->
<!--                  <el-col :span="6">-->
<!--                    <el-form-item label="月卡套餐">-->
<!--                      <el-input v-model="carPay.ruleName" disabled></el-input>-->
<!--                    </el-form-item>-->
<!--                  </el-col>-->
<!--                  <el-col :span="8">-->
<!--                    <el-form-item label="收费规则">-->
<!--                      <el-input v-model="carPay2.preferentName" disabled></el-input>-->
<!--                    </el-form-item>-->
<!--                  </el-col>-->
<!--                </el-row>-->
<!--                <el-row>-->
<!--                  <el-col :span="6">-->
<!--                    <el-form-item label="费用总额(元)" label-width="100px">-->
<!--                      <el-input-->
<!--                        v-model="carPay.calAmount"-->
<!--                        disabled-->
<!--                        :class="{-->
<!--                          danger: carPay.calAmount !== 0,-->
<!--                        }"-->
<!--                      ></el-input>-->
<!--                    </el-form-item>-->
<!--                  </el-col>-->
<!--                  &lt;!&ndash;                  <el-col :span="6">&ndash;&gt;-->
<!--                  &lt;!&ndash;                    <el-form-item label="优惠券抵扣(元)" label-width="112px">&ndash;&gt;-->
<!--                  &lt;!&ndash;                      <el-input&ndash;&gt;-->
<!--                  &lt;!&ndash;                        v-model="carPay.couponAmount"&ndash;&gt;-->
<!--                  &lt;!&ndash;                        :disabled="carPay2.couponFlag === 0 || !carPay.calAmount"&ndash;&gt;-->
<!--                  &lt;!&ndash;                      ></el-input>&ndash;&gt;-->
<!--                  &lt;!&ndash;                    </el-form-item>&ndash;&gt;-->
<!--                  &lt;!&ndash;                  </el-col>&ndash;&gt;-->
<!--                  <el-col :span="6">-->
<!--                    <el-form-item label="应收金额(元)" label-width="100px">-->
<!--                      <el-input v-model="carPay.shouldAmount" disabled></el-input>-->
<!--                    </el-form-item>-->
<!--                  </el-col>-->
<!--                </el-row>-->
<!--              </el-form>-->
<!--            </el-col>-->
<!--            <el-col :span="4">-->
<!--              <div style="padding-left: 32px">-->
<!--                <el-button-->
<!--                  type="primary"-->
<!--                  :disabled="isSuccess || selected.carPay"-->
<!--                  @click="confirmCarPay"-->
<!--                  >选中</el-button-->
<!--                >-->
<!--                <el-button type="danger" :disabled="isSuccess" @click="cancelCarPay"-->
<!--                  >取消</el-button-->
<!--                >-->
<!--              </div>-->
<!--            </el-col>-->
<!--          </el-row>-->
<!--        </el-tab-pane>-->
        <el-tab-pane name="4">
          <span slot="label">
            <i v-show="selected.temporaryPay" class="el-icon-s-flag" style="color: #f56c6c"></i>
            临时收费
          </span>
          <el-row>
            <el-col :span="20">
              <el-form
                label-width="108px"
                ref="temporaryPay"
                :model="temporaryPay"
                :rules="temporaryPayRules"
                :disabled="selected.temporaryPay"
              >
                <el-row>
                  <el-col :span="6">
                    <el-form-item label="费项名称" prop="itemsetId">
                      <el-select
                        v-model="temporaryPay.itemsetId"
                        placeholder="请选择"
                        @change="selectTemporaryPayItem"
                      >
                        <el-option
                          v-for="item in temporaryPay2.itemList"
                          :key="item.itemsetId"
                          :label="item.feeItemName"
                          :value="item.itemsetId"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item
                      label
                      :prop="temporaryPay2.sortType !== 39 ? 'itemsetId' : 'defItemset'"
                      label-width="20px"
                    >
                      <el-input
                        v-model="temporaryPay.defItemset"
                        :disabled="temporaryPay2.sortType !== 39"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="费项起止日期" label-width="120px">
                      <el-date-picker
                        v-model="temporaryPay2.dateRange"
                        type="daterange"
                        range-separator="~"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <el-form-item label="收费原因">
                      <el-input v-model="temporaryPay.reason"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="6">
                    <el-form-item label="临时费用(元)" prop="calAmount">
                      <el-input
                        v-model="temporaryPay.calAmount"
                        :disabled="!temporaryPay.itemsetId"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="政策优惠(元)">
                      <el-input v-model="temporaryPay.derateAmount" disabled></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="优惠券抵扣(元)" label-width="112px" prop="couponAmount">
                      <el-input
                        v-model="temporaryPay.couponAmount"
                        :disabled="temporaryPay2.couponFlag === 0 || !temporaryPay.calAmount"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="应收金额(元)">
                      <el-input v-model="temporaryPay.shouldAmount" disabled></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </el-col>
            <el-col :span="4">
              <div style="padding-left: 32px">
                <el-button
                  type="primary"
                  :disabled="isSuccess || selected.temporaryPay"
                  @click="confirmTemporaryPay"
                  >选中</el-button
                >
                <el-button type="danger" :disabled="isSuccess" @click="cancelTemporaryPay"
                  >取消</el-button
                >
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane name="5" label="优惠政策">
          <el-table
            :data="yhzc.list"
            stripe
            border
            style="width: 100%; margin-bottom: 26px; max-height: 500px"
          >
            <el-table-column prop="feeItemName" label="费用名称" width="150px"></el-table-column>
            <el-table-column
              prop="preferentName"
              label="优惠政策名称"
              width="120px"
            ></el-table-column>
            <el-table-column prop="useTime" label="政策开始时间" width="140px"></el-table-column>
            <el-table-column prop="stopTime" label="政策结束时间" width="140px"></el-table-column>
            <el-table-column prop="payTypeName" label="收费方式"></el-table-column>
            <el-table-column prop="feeCycleName" label="收费周期"></el-table-column>
            <el-table-column
              prop="includeFlagName"
              label="是否含本月"
              width="88px"
            ></el-table-column>
            <el-table-column prop="preferentTypeName" label="优惠方式"></el-table-column>
            <el-table-column
              prop="preferentScore"
              label="优惠额度(元)/折扣(%)"
              width="140px"
            ></el-table-column>
            <el-table-column prop="remark1" label="备注"></el-table-column>
          </el-table>
        </el-tab-pane>
        <!--        <el-tab-pane name="6" label="积分余额">-->
        <!--          <el-form label-width="100px" ref="jfye" :rules="jfyeRules" :model="jfye">-->
        <!--            <el-row>-->
        <!--              <el-col :span="6">-->
        <!--                <el-form-item label="住户" prop="householdId">-->
        <!--                  <el-select-->
        <!--                    v-model="jfye.householdId"-->
        <!--                    placeholder="请选择"-->
        <!--                    @change="selectHouseHold"-->
        <!--                  >-->
        <!--                    <el-option-->
        <!--                      v-for="item in jfye.accounts"-->
        <!--                      :key="item.householdId"-->
        <!--                      :label="item.householdName"-->
        <!--                      :value="item.householdId"-->
        <!--                    >-->
        <!--                    </el-option>-->
        <!--                  </el-select>-->
        <!--                </el-form-item>-->
        <!--              </el-col>-->
        <!--              <el-col :span="6">-->
        <!--                <el-form-item label="账户余额(元)">-->
        <!--                  <el-input v-model="jfye.accountAmount" disabled></el-input>-->
        <!--                </el-form-item>-->
        <!--              </el-col>-->
        <!--              <el-col :span="6">-->
        <!--                <el-form-item label="当前积分">-->
        <!--                  <el-input v-model="jfye.pointsNumber" disabled></el-input>-->
        <!--                </el-form-item>-->
        <!--              </el-col>-->
        <!--            </el-row>-->
        <!--            <el-row>-->
        <!--              <el-col :span="18">-->
        <!--                <el-form-item label="积分兑换策略">-->
        <!--                  <el-input v-model="jfye.preferentName" disabled></el-input>-->
        <!--                </el-form-item>-->
        <!--              </el-col>-->
        <!--              <el-col :span="6">-->
        <!--                <el-form-item label-width="32px">-->
        <!--                  <el-button type="primary" @click="exchangePoints">兑换</el-button>-->
        <!--                </el-form-item>-->
        <!--              </el-col>-->
        <!--            </el-row>-->
        <!--            <el-row>-->
        <!--              <el-col :span="6">-->
        <!--                <el-form-item label="兑换账号" prop="exchangeId">-->
        <!--                  <el-select v-model="jfye.exchangeId" placeholder="请选择">-->
        <!--                    <el-option-->
        <!--                      v-for="item in jfye.accounts"-->
        <!--                      :key="item.householdId"-->
        <!--                      :label="item.householdName"-->
        <!--                      :value="item.householdId"-->
        <!--                    >-->
        <!--                    </el-option>-->
        <!--                  </el-select>-->
        <!--                </el-form-item>-->
        <!--              </el-col>-->
        <!--              <el-col :span="6">-->
        <!--                <el-form-item label="兑换积分" prop="exchangePoints">-->
        <!--                  <el-input v-model="jfye.exchangePoints"></el-input>-->
        <!--                </el-form-item>-->
        <!--              </el-col>-->
        <!--              <el-col :span="6">-->
        <!--                <el-form-item label="兑换金额(元)" label-width="120px">-->
        <!--                  <el-input v-model="jfyeCP.exchangeAmount" disabled></el-input>-->
        <!--                </el-form-item>-->
        <!--              </el-col>-->
        <!--            </el-row>-->
        <!--          </el-form>-->
        <!--        </el-tab-pane>-->
      </el-tabs>
    </div>
    <div>
      <div class="title">
        收费信息
        <el-input
          v-model="payInfo.payBillNo"
          disabled
          style="width: 200px; margin-left: 32px"
        ></el-input>
      </div>
      <el-divider></el-divider>
      <el-form label-width="100px" ref="payInfo" :rules="payInfoRules" :model="payInfo">
        <el-row>
          <el-col class="el-col-4_8">
            <el-form-item label="账单总额(元)">
              <el-input v-model="billTotalAmountCP" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col class="el-col-4_8">
            <el-form-item label="预收总额(元)">
              <el-input v-model="preTotalAmountCP" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col class="el-col-4_8">
            <el-form-item label="车辆费(元)">
              <el-input v-model="carTotalAmountCP" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col class="el-col-4_8">
            <el-form-item label="临时收费(元)">
              <el-input v-model="temporaryTotalAmountCP" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col class="el-col-4_8">
            <el-form-item label="应收总额(元)">
              <el-input v-model="totalShouldAmountCP" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <!--          <el-col class="el-col-4_8">-->
          <!--            <el-form-item label="账户余额(元)">-->
          <!--              <el-input v-model="payInfo.accountAmount" disabled></el-input>-->
          <!--            </el-form-item>-->
          <!--          </el-col>-->
          <!--          <el-col class="el-col-4_8">-->
          <!--            <el-form-item label="账户抵扣(元)" prop="totalAccountpayAmount">-->
          <!--              <el-input v-model="payInfo.totalAccountpayAmount"></el-input>-->
          <!--            </el-form-item>-->
          <!--          </el-col>-->
          <el-col class="el-col-4_8">
            <el-form-item label="收费金额(元)" prop="totalPayAmount" label-width="108px">
              <el-input v-model="payInfo.totalPayAmount" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col class="el-col-4_8">
            <el-form-item label="收款方式" label-width="80px">
              <el-select
                v-model="payInfo.paylabel"
                @change="changeValue"
                placeholder="请选择"
                class="pay-type"
              >
                <el-option
                  v-for="item in dict"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
              <!-- <van-button
                type="default"
                icon="qr"
                size="small"
                class="pay-qrcode"
                native-type="button"
                :disabled="
                  isSuccess ||
                  totalShouldAmountCP === 0 ||
                  (payInfo.payType !== 2 && payInfo.payType !== 3)
                "
                @click="genearateQrCode"
              ></van-button> -->
              <van-button
                type="default"
                icon="qr"
                size="small"
                class="pay-qrcode"
                native-type="button"
                :disabled="
                  isSuccess ||
                  totalShouldAmountCP === 0 ||
                  (payInfo.payType !== 2 && payInfo.payType !== 3 && payInfo.payType !== 7)
                "
                @click="genearateQrCode"
              ></van-button>
            </el-form-item>
          </el-col>
          <el-col class="el-col-4_8">
            <el-form-item label="付款码" label-width="60px">
              <div style="position: relative" ref="payAuthCode" @click="payAuthCodeClickHandler">
                <el-button
                  style="z-index: 101; position: absolute; right: -60px"
                  @click="clearPaycodeBtnHandler"
                  >清空</el-button
                >
                <!-- <el-input autocomplete="off" v-model="payInfo.authCode" type="password" maxlength="18" @blur="payAuthCodeBlurHandler" @input="payAuthCodeInputHandler" @focus="payAuthCodeFocusHandler" style="z-index:100;border:1px solid red;position:absolute;"></el-input> -->
                <el-input
                  v-model="payInfo.authCode"
                  type="text"
                  maxlength="18"
                  @blur="payAuthCodeBlurHandler"
                  @input="payAuthCodeInputHandler"
                  @focus="payAuthCodeFocusHandler"
                  style="z-index: 100; opacity: 0; border: 1px solid red; position: absolute"
                ></el-input>
                <el-input
                  v-model="payInfo.authCode"
                  type="password"
                  maxlength="18"
                  readonly
                  clearable
                ></el-input>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="收费明细">
              <el-table :data="payInfo2.payDetailList" border height="200px" class="bill-table2">
                <el-table-column prop="feeName" label="费用名称"></el-table-column>
                <el-table-column prop="feePeriod" label="账期"></el-table-column>
                <el-table-column prop="calAmount" label="费用金额" width="100px"></el-table-column>
                <el-table-column
                  prop="derateAmount"
                  label="优惠金额"
                  width="100px"
                ></el-table-column>
                <el-table-column
                  prop="couponAmount"
                  label="抵扣金额"
                  width="100px"
                ></el-table-column>
                <el-table-column
                  prop="shouldAmount"
                  label="应收金额"
                  width="100px"
                ></el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="收费备注">
              <el-input
                type="textarea"
                :rows="4"
                placeholder="请输入内容"
                v-model="payInfo.payRemark"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="32">
          <el-col style="text-align: center">
            <el-button
              type="primary"
              @click="makeCollections"
              :disabled="isSuccess || totalShouldAmountCP === 0"
              >收款</el-button
            >
            <el-button type="primary" @click="printprev">打印</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-dialog
      title="选择房产"
      :visible.sync="showRoomSelect"
      width="30%"
      top="16vh"
      custom-class="room-select-dialog"
      append-to-body
      :show-close="false"
      :close-on-click-modal="false"
      center
      @close="showRoomSelect = false"
    >
      <RoomSelect v-if="roomSelectFlag" @select="selectRoom" :communityGroup.sync="communityGroup"></RoomSelect>
      <span slot="footer">
        <el-button @click="showRoomSelect = false">取消</el-button>
        <el-button type="primary" @click="confirmRoom">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="收款码"
      :visible.sync="payInfo2.showQrCode"
      :close-on-click-modal="false"
      width="30%"
      top="16vh"
      append-to-body
      @close="closeQrCode"
    >
      <div style="text-align: center; color: red; font-size: 2rem; padding: 1rem 0">
        {{ payInfo2.tradeStatus === 2 ? '付款成功' : '付款中' }}
      </div>
      <div style="text-align: center; color: red; font-size: 1rem; padding: 1rem 0">
        扫码支付后请勿手动关闭弹窗
      </div>
      <div style="text-align: center">
        <div id="qrcode" ref="qrcode" style="display: inline-block"></div>
        <div>倒计时：{{ payInfo2.countdown }}</div>
      </div>
    </el-dialog>
    <printPreview ref="printPreview"></printPreview>
    <!-- 全屏遮罩 -->
    <el-dialog
      title="支付处理中..."
      :visible.sync="statusDialogVisible"
      width="30%"
      center
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
      :mask="true"
    >
      <div style="text-align: center">{{ statusDuration }}</div>
    </el-dialog>
  </basic-container>
</template>

<script>
import QRCode from 'qrcodejs2';
import NP from 'number-precision';
import RoomSelect from '@/components/room-select';
import printPreview from '@/views/v4ward/pay/printdialog/printPreview';
import {getCommunityGroupList,
  loadZhxx,
  loadQfxx,
  loadBill,
  loadPrePayItem,
  loadPrePayStartCycle,
  loadPrePayPreferent,
  loadPrePayAmount,
  loadCarPayPark,
  loadCarPayMonthCarNo,
  loadCarPayBackAmount,
  loadCarPayMonthCarStartTime,
  loadCarPayAmount,
  loadCarPayBill,
  loadTemporaryPayItem,
  loadTemporaryPayPreferent,
  loadTemporaryPayAmount,
  loadYhzc,
  loadJfye,
  updateBill,
  updateJfye,
  loadAccountAmount,
  saveAllBill,
  saveQrCodePay,
  saveBarCodePay,
  loadPayStatus,
  payType,
  bankBillStatus,
} from '@/api/charge';
import { mapGetters } from 'vuex';
//住户信息、欠费信息
const zhxxMix = {
  components: { RoomSelect, printPreview },
  data() {
    return {
      roomSelectFlag:false,
      communityGroupList: [],
      communityGroup:'',
      carNoList: [],
      //租户信息
      zhxx: {
        shortCode: '',
        roomId: '',
        roomName: '',
        roomLayout: '',
        roomLayoutName: '',
        roomType: '',
        roomTypeName: '',
        roomStatus: '',
        roomStatusName: '',
        floorage: '',
        usableArea: '',
        roomOrientations: '',
        roomOrientationsName: '',
        useFlag: '',
        additionAreaFlag: 0,
        parkingAreaFlag: 0,
        loftAreaFlag: 0,
        householder: '',
        householderPhone: '',
        leaseholder: '',
        leaseholderPhone: '',
        carNo1: '',
        carStatus1: 0,
        carNo2: '',
        carStatus2: 1,
      },
      //欠费信息
      qfxx: {
        totalAmount: 0, //当前欠费
        propertyAmount: 0, //物业费
        otherAmount: 0, //其他自收费
        proxyAmount: 0, //代收费
      },
      temp: {
        roomId: '',
      },
      showRoomSelect: false,
    };
  },
  mounted(){
    getCommunityGroupList().then((res)=>{
      this.communityGroupList = res.data;
    });
  },
  watch: {
    //监听房产Id
    'zhxx.roomId'(val) {
      if (this.vdui.isEmpty(val)) {
        return;
      }
      this.payInfo2.payDetailList = [];
      this.billPay.feeBillList = [];
      this.prePay = {
        itemsetId: '',
        feeSort: '',
        payUse: 1,
        billcycleNo: '',
        cycleNum: '',
        billStartDate: '',
        billEndDate: '',
        calAmount: '',
        derateAmount: '',
        couponAmount: '',
        shouldAmount: '',
        payAmount: '',
        itemsetPreferentList: [],
      };
      this.temporaryPay = {
        itemsetId: '',
        feeSort: '',
        defItemset: '',
        startDate: '',
        endDate: '',
        reason: '',
        calAmount: '',
        derateAmount: '',
        couponAmount: '',
        shouldAmount: '',
        payAmount: '',
        itemsetPreferentList: [],
      };
      //积分余额:这个模块已被注释2020-07-14
      this.jfye = {
        householdId: '',
        householdName: '',
        accountAmount: '',
        pointsNumber: 0,
        preferentName: '',
        exchangeId: '',
        exchangePoints: '',
        exchangeAmount: '',
        accounts: [],
        preferents: [],
      };
      //支付完成后生成的单号,页面文字:收费信息
      this.payInfo.payBillNo = '';
      //模块 是否可输入 的状态
      this.selected = {
        billPay: false,
        prePay: false,
        carPay: false,
        temporaryPay: false,
      };
      this.$nextTick(() => {
        this.$refs.prePay.clearValidate();
        this.$refs.temporaryPay.clearValidate();
      });

      this.isSuccess = false;
      this.queryQfxx();
      this.queryBill();
      this.queryPrePayItem().then(() => {
        this.prePay.itemsetId = this.prePay2.itemList[0].itemsetId;
        this.selectPrePayItem(this.prePay.itemsetId);
      });
      this.queryCarPayPark('').then(() => {
        this.carPay.communityId = this.carPay2.parkList[0].communityId;
        this.selectCarPayPark(this.carPay.communityId);
      });
      this.queryTemporaryPayItem().then(() => {
        this.temporaryPay.itemsetId =
          this.temporaryPay2.itemList.length > 0 ? this.temporaryPay2.itemList[0].itemsetId : '';
        this.selectTemporaryPayItem(this.temporaryPay.itemsetId);
      });
      //优惠政策
      this.queryYhzc();
      //积分余额:未使用
      this.queryJfye();
      //查询缴费人员id和缴费账户余额
      this.queryAccountAmount();
    },
  },
  methods: {
    communityGroupChangeHandler(val){
      // this.communityGroup = val;
      this.roomSelectFlag = false;
      setTimeout(()=>{
      this.roomSelectFlag = true;
      })
    },
    clearPaycodeBtnHandler() {
      this.payInfo = Object.assign({}, this.payInfo, { authCode: '' });
    },
    payAuthCodeClickHandler() {
      let authCode = this.payInfo.authCode;
      this.payInfo = Object.assign({}, this.payInfo, { authCode: '' });
      setTimeout(() => {
        this.payInfo = Object.assign({}, this.payInfo, { authCode: authCode });
      });
      // console.log(authCode);
    },
    payAuthCodeInputHandler(e) {
      // this.payInfo.authCode = e;
      this.payInfo = Object.assign({}, this.payInfo, { authCode: e });
      console.log(e);
      console.log(this.payInfo.authCode);
    },
    payAuthCodeFocusHandler(e) {
      this.$refs.payAuthCode;
      this.$refs.payAuthCode.style.cssText =
        'position:relative;border:1px solid red;border-radius: 5px;';
      // console.log("payAuthCodeFocusHandler(e)=====>",this.$refs.payAuthCode.style.cssText="position:relative;border:1px solid red;border-radius: 5px;");
    },
    payAuthCodeBlurHandler(e) {
      this.$refs.payAuthCode;
      this.$refs.payAuthCode.style.cssText = 'position:relative;';
      // console.log("payAuthCodeBlurHandler(e)=====>",this.$refs.payAuthCode.style.cssText="position:relative;");
    },
    onInputFocusHandler(e) {
      this.selectCarPayCarNo({ carNo: e });
      this.selectCarPayCarNo_Blur();
    },
    //查询速记码
    queryShortCode(qs, cb) {
      if (qs.length < 3) {
        cb();
        return;
      }
      loadZhxx({ shortCode: qs }).then(({ data }) => {
        if (this.vdui.isEmpty(data)) {
          cb();
          this.$message.info('未查询到住户信息');
        } else if (data.length === 1) {
          this.zhxx = data[0];
          cb();
        } else {
          this._.forEach(data, (item) => {
            item.value = item.shortCode;
          });
          cb(data);
        }
      });
    },
    //选择速记码
    selectShortCode(item) {
      this.queryZhxx({ shortCode: item.shortCode });
    },
    //选择房产
    selectRoom(item) {
      this.temp.roomId = item.roomId;
    },
    //确认选定房产
    confirmRoom() {
      this.showRoomSelect = false;
      if (this.temp.roomId) {
        this.zhxx.roomId = this.temp.roomId;
        this.queryZhxx({ roomId: this.zhxx.roomId });
      }
    },
    //查询住户信息
    queryZhxx(params) {
      loadZhxx(params).then(({ data }) => {
        this.zhxx = data[0];
      });
    },
    //查询欠费信息
    queryQfxx(params) {
      loadQfxx({ roomId: this.zhxx.roomId }).then(({ data }) => {
        this.qfxx = data;
      });
    },
  },
};
//账单明细
const zdsfMix = {
  data() {
    return {
      billPay: {
        sumOfAmount: '',
        feeBillList: [], //账单收费:已勾选的账单列表
      },
      //账单收费
      billPay2: {
        propertyAmountCheck: 1, //账单收费:物业费checkbox
        otherAmountCheck: 1, //账单收费:其他自收费checkbox
        proxyAmountCheck: 1, //账单收费:代收费checkbox
        list: [], //账单收费:全部账单列表
      },
    };
  },
  mounted() {
    //根据按钮权限改变费项值
    this.billPay2.propertyAmountCheck = this.permissions.propertyAmountCheck ? 1 : 0;
    this.billPay2.otherAmountCheck = this.permissions.otherAmountCheck ? 1 : 0;
    this.billPay2.proxyAmountCheck = this.permissions.proxyAmountCheck ? 1 : 0;
  },
  methods: {
    fixFeeBillListNum(list){
      list.forEach(element => {
        element.billShouldAmount = parseFloat(element.billShouldAmount);
      });
      console.log("fixFeeBillListNum=====>",list);
    },
    //账单明细table勾选
    onBillSelectionChange(val) {
      console.log('账单明细table勾选==>', val);
      this.fixFeeBillListNum(val)
      this.billPay.feeBillList = val;
      //NP:number-precision
      this.billPay.sumOfAmount = NP.strip(this._.sumBy(val, 'billShouldAmount'));
      this.billPay.sumOfAmount = Math.round(this.billPay.sumOfAmount * 100) / 100
    },
    //设置账单明细是否可全选
    setBillTableSelect(row, index) {
      return !this.selected.billPay;
    },
    //查询账单明细
    queryBill() {
      loadBill(
        {
          roomId: this.zhxx.roomId,
          propertyAmountCheck: this.billPay2.propertyAmountCheck,
          otherAmountCheck: this.billPay2.otherAmountCheck,
          proxyAmountCheck: this.billPay2.proxyAmountCheck,
        },
        { showLoading: { text: '查询中' } }
      ).then(({ data }) => {
        this.billPay2.list = data.feeBillList;
      });
    },
    //修改账单明细优惠
    updateBill(row) {
      if (!/^([0-9]+(\.[0-9]{1,2})?)$/.test(row.billCouponAmount)) {
        this.$message.error('格式错误');
        return;
      }
      if (row.billCouponAmount > row.calAmount) {
        this.$message.error('不能超过理论金额');
        return;
      }
      updateBill(
        { billId: row.billId, billCouponAmount: row.billCouponAmount },
        { showLoading: { text: '更新账单明细' } }
      ).then(() => {
        this.queryBill();
      });
    },

    isPayBillLock(feeBillList) {
      let isLock = false;
      let index_ = 0;
      for (let index = 0; index < feeBillList.length; index++) {
        // const element = feeBillList[index];
        if (parseInt(feeBillList[index].lockFlag) == 1) {
          isLock = true;
          index_ = index;
          break;
        }
      }
      // feeBillList.forEach((v,i)=>{
      //   console.log(v,i);
      // });
      return { isLock, index_: index_ };
    },
    //选中
    confirmBillPay() {
      // this.payInfo.authCode
      this.payInfo = Object.assign({}, this.payInfo, { authCode: '' });
      if (this.vdui.isEmpty(this.billPay.feeBillList)) {
        this.$message.warning('请选择账单');
        return;
      }

      let arrayLength = this.billPay.feeBillList.length;
      // this.billPay.feeBillList.push(this.billPay.feeBillList[arrayLength-1]);
      // this.billPay.feeBillList[arrayLength-1].lockFlag = 1;
      console.log(this.billPay.feeBillList);
      console.log(this.isPayBillLock(this.billPay.feeBillList));

      let isLockedObject = this.isPayBillLock(this.billPay.feeBillList);
      let self = this;

      if (isLockedObject.isLock) {
        this.$message.warning(
          `"${self.billPay.feeBillList[isLockedObject.index_].billFeeItemName}"正在划扣中！`
        );
        return;
      }
      // return;
      this.selected.billPay = true;
      this._.forEach(this.billPay.feeBillList, (item) => {
        this.payInfo2.payDetailList.push({
          feeType: 'billPay',
          feeName: item.billFeeItemName,
          feePeriod: item.billStartDate + ' - ' + item.billEndDate,
          calAmount: item.calAmount + '',
          derateAmount: item.billPreferentAmount + '',
          couponAmount: item.billCouponAmount + '',
          shouldAmount: item.billShouldAmount + '',
        });
      });
    },
    //取消
    cancelBillPay() {
      this.payInfo = Object.assign({}, this.payInfo, { authCode: '' });
      this.selected.billPay = false;
      this.payInfo2.payDetailList = this.payInfo2.payDetailList.filter(
        (item) => item.feeType !== 'billPay'
      );
    },
  },
};
//预收费
const ysfMix = {
  data() {
    return {
      // bankBillStatusList:[],
      prePay: {
        itemsetId: '',
        feeSort: '',
        payUse: 1,
        billcycleNo: '', //周期数
        cycleNum: '',
        billStartDate: '',
        billEndDate: '',
        calAmount: '',
        derateAmount: '',
        couponAmount: '',
        shouldAmount: '',
        payAmount: '',
        itemsetPreferentList: [],
      },
      prePay2: {
        itemList: [], //费项
        billStartDateList: [],
        preferentName: '',
        accountFlag: 0,
        couponFlag: 0,
        feeName: '',
      },
      prePayRules: {
        itemsetId: [{ required: true, message: '请选择费项', trigger: 'change' }],
        billcycleNo: [{ required: true, message: '请选择开始周期', trigger: 'change' }],
        cycleNum: [
          { required: true, message: '请输入期数', trigger: 'change' },
          { pattern: /^[0-9]*[1-9][0-9]*$/, message: '请输入正整数', trigger: 'change' },
          { min: 0, max: 2, message: '期数超长' },
        ],
        calAmount: [
          { required: true, message: '请输入充值金额', trigger: 'change' },
          { pattern: /^[0-9]*[0-9][0-9]*$/, message: '请输入正整数', trigger: 'change' },
        ],
        couponAmount: [
          { pattern: /^([0-9]+(\.[0-9]{1,2})?)$/, message: '格式错误', trigger: 'change' },
          { validator: this.validatePrePayCouponAmount, trigger: 'change' },
        ],
      },
    };
  },
  watch: {
    //监听费项
    'prePay.itemsetId'(val) {
      if (this.vdui.isEmpty(val)) {
        return;
      }
      this.prePay = {
        itemsetId: val,
        feeSort: this.prePay.feeSort,
        payUse: 1,
        billcycleNo: '',
        cycleNum: '',
        billStartDate: '',
        billEndDate: '',
        calAmount: '',
        derateAmount: '',
        couponAmount: '',
        shouldAmount: '',
        payAmount: '',
        itemsetPreferentList: [],
      };
      this.$nextTick(() => {
        this.$refs.prePay.clearValidate();
      });

      this.queryPrePayPreferent();
      this.queryPrePayStartCycle();
    },
    //监听期数
    'prePay.cycleNum': _.debounce(function () {
      if (
        this.vdui.isEmpty(this.prePay.cycleNum) ||
        this.prePay.cycleNum.length > 2 ||
        !/^[0-9]*[1-9][0-9]*$/.test(this.prePay.cycleNum)
      ) {
        return;
      }
      this.queryPrePayAmount();
    }, 500),
    //监听监听预收费-优惠券折扣
    'prePay.couponAmount': _.debounce(function () {
      // if (this.vdui.isNotEmpty(this.prePay.couponAmount)) {
      //   let shouldAmount = NP.strip(
      //     this.prePay.calAmount - this.prePay.derateAmount - this.prePay.couponAmount
      //   );
      //   this.prePay.shouldAmount = shouldAmount < 0 ? '' : shouldAmount;
      // }
    }, 1000),
  },
  methods: {
    //校验抵扣额
    validatePrePayCouponAmount(rule, value, callback) {
      if (this.vdui.isEmpty(value) || value === 0) {
        callback();
      } else if (value < this.prePay.calAmount - this.prePay.derateAmount) {
        callback();
      } else {
        callback(new Error('抵扣已超额'));
      }
    },
    //选择费项
    selectPrePayItem(val) {
      let item = this.prePay2.itemList.filter((item) => item.itemsetId === val)[0];
      this.prePay.feeSort = item.feeSort;
      this.prePay2.feeName = item.advanceFeeItemName;
      this.prePay2.feeStopTime = item.stopTime;
    },
    //校验费项截止日期是否大于设置日期
    validPrePayFeeStopTime(){
      let self = this;
      let tempTimeRange = (new Date(self.prePay2.feeStopTime)).getTime()-(new Date(self.prePay.billEndDate)).getTime()
      if(tempTimeRange<0){
        return false;
      }else{
        return true;
      }
    },
    //选择开始周期
    selectBillcycleNo(val) {
      let item = this.prePay2.billStartDateList.filter((item) => item.billcycleNo === val)[0];
      this.prePay.billStartDate = item.billStartDate;
      if (this.vdui.isNotEmpty(this.prePay.cycleNum)) {
        this.queryPrePayAmount();
      }
    },
    //查询费项
    queryPrePayItem() {
      return loadPrePayItem({ roomId: this.zhxx.roomId }).then(({ data }) => {
        this.prePay2.itemList = data;
      });
    },
    //查询预收费优惠政策
    queryPrePayPreferent() {
      loadPrePayPreferent({
        roomId: this.zhxx.roomId,
        itemsetId: this.prePay.itemsetId,
        payUse: this.prePay.payUse,
      }).then(({ data }) => {
        this.prePay2.preferentName = this._.map(data, 'preferentName').join(',');
      });
    },
    //查询开始周期
    queryPrePayStartCycle() {
      loadPrePayStartCycle({
        roomId: this.zhxx.roomId,
        itemsetId: this.prePay.itemsetId,
      }).then(({ data }) => {
        this.prePay2.billStartDateList = data;
      });
    },
    //查询预收费金额
    queryPrePayAmount() {
      // console.log('isSuccess',this.isSuccess);
      // console.log('selected.billPay',this.selected.billPay);
      // this.prePay.billStartDate = '';
      // this.prePay.billEndDate = '';
      this.prePay.calAmount = '';
      this.prePay.derateAmount = '';
      this.prePay.couponAmount = '';
      this.prePay.shouldAmount = '';
      this.prePay.payAmount = '';
      this.prePay.itemsetPreferentList = '';
      this.prePay2.accountFlag = '';
      this.prePay2.couponFlag = '';
      loadPrePayAmount(
        {
          roomId: this.zhxx.roomId,
          itemsetId: this.prePay.itemsetId,
          payUse: this.prePay.payUse,
          billcycleNo: this.prePay.billcycleNo,
          cycleNum: this.prePay.cycleNum,
          billStartDate: this.prePay.billStartDate,
          calAmount: this.prePay.calAmount,
        },
        { showLoading: { text: '查询中' } }
      ).then(({ data }) => {
        this.prePay.billStartDate = data.billStartDate;
        this.prePay.billEndDate = data.billEndDate;
        this.prePay.calAmount = data.calAmount;
        this.prePay.derateAmount = data.derateAmount;
        this.prePay.couponAmount = data.couponAmount;
        this.prePay.shouldAmount = data.shouldAmount;
        this.prePay.payAmount = data.payAmount;
        this.prePay.itemsetPreferentList = data.itemsetPreferentList;
        this.prePay2.accountFlag = data.accountFlag;
        this.prePay2.couponFlag = data.couponFlag;

        console.log(this.prePay.shouldAmount);
      });
    },
    //选中
    confirmPrePay() {
      if( this.prePay.billEndDate && !this.validPrePayFeeStopTime() ){
        this.$confirm(`账单截至日期为‘${this.prePay2.feeStopTime}’，是否继续？`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.prePay.billEndDate = this.prePay2.feeStopTime;
            // this.$message({
            //   type: 'success',
            //   message: '删除成功!'
            // });
            this.validPrePayForm();
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            });
          });
      }else{
        this.validPrePayForm();
      }
    },
    validPrePayForm(){
      this.payInfo = Object.assign({}, this.payInfo, { authCode: '' });
      // if(this.prePay.shouldAmount===0){
      //   this.$message.error('有账单正在处理中, 不允许缴费!');
      //   return;
      // }
      this.$refs.prePay.validate((valid) => {
        if (valid) {
          this.selected.prePay = true;
          this.payInfo2.payDetailList.push({
            feeType: 'prePay',
            feeName: this.prePay2.feeName,
            feePeriod: this.prePay.billStartDate + ' - ' + this.prePay.billEndDate,
            calAmount: this.prePay.calAmount + '',
            derateAmount: this.prePay.derateAmount + '',
            couponAmount: this.prePay.couponAmount + '',
            shouldAmount: this.prePay.shouldAmount + '',
          });
        }
      });
    },
    //取消
    cancelPrePay() {
      this.payInfo = Object.assign({}, this.payInfo, { authCode: '' });
      this.selected.prePay = false;
      this.payInfo2.payDetailList = this.payInfo2.payDetailList.filter(
        (item) => item.feeType !== 'prePay'
      );
    },
  },
};
//车辆收费
const clsfMix = {
  data() {
    return {
      carPay: {
        itemsetId: '',
        feeSort: '',
        propertyId: '',
        carNo: '',
        carPayType: '',
        billcycleNo: '',
        cycleNum: '',
        calAmount: '',
        derateAmount: '',
        couponAmount: '',
        shouldAmount: '',
        payAmount: '',
        ruleId: '',
        ruleName: '',
        startTime: '',
        backAmount: '',
        backType: 1,
        communityId: '',
        roomId: '', //如果不选择 住房 直接选择 车辆缴费,则住房信息在 getPayMoney 接口中带入 fix:20200605 pengyichao
        roomName: '', // 同上
      },
      carPay2: {
        parkList: [],
        billList: [],
        monthList: [
          {
            value: '1',
            label: '1',
          },
          {
            value: '2',
            label: '2',
          },
          {
            value: '3',
            label: '3',
          },
          {
            value: '4',
            label: '4',
          },
          {
            value: '5',
            label: '5',
          },
          {
            value: '6',
            label: '6',
          },
          {
            value: '7',
            label: '7',
          },
          {
            value: '8',
            label: '8',
          },
          {
            value: '9',
            label: '9',
          },
          {
            value: '10',
            label: '10',
          },
          {
            value: '11',
            label: '11',
          },
          {
            value: '12',
            label: '12',
          },
        ],
        ruleList: [],
        preferentName: '',
        couponFlag: 0,
        feeName: '',
        endTime: '',
      },
      carPayRules: {
        communityId: [{ required: true, message: '请选择停车场', trigger: 'change' }],
        carNo: [{ required: true, message: '请选择车牌号', trigger: 'change' }],
        startTime: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
        cycleNum: [{ required: true, message: '请选择套餐周期', trigger: 'change' }],
      },
    };
  },
  watch: {
    //监听欠费
    'carPay.backAmount'() {
      this.queryCarPayMonthCarStartTime();
    },
    //监听补缴方式
    'carPay.backType'() {
      this.resetCarPay_();
      this.queryCarPayMonthCarStartTime_();
    },
    //监听月卡套餐
    'carPay.ruleId'() {
      this.queryCarPayAmount();
    },
    //监听开始时间
    'carPay.startTime'() {
      this.queryCarPayAmount();
    },
    //监听套餐周期
    'carPay.cycleNum'() {
      this.queryCarPayAmount();
    },
    //监听优惠券抵扣
    'carPay.couponAmount': _.debounce(function () {
      this.queryCarPayAmount();
    }, 1000),
  },
  methods: {
    resetCarPay_() {
      //重置表单内容
      this.carPay2.ruleList = [];
      this.carPay2.preferentName = '';
      this.carPay.startTime = '';
      this.carPay.ruleId = '';
      this.carPay.ruleName = '';
      this.carPay.roomId = '';
      this.carPay.roomName = '';
      this.carPay.cycleNum = '';
      this.carPay.calAmount = '';
      this.carPay.shouldAmount = '';
      // this.carPay.carNo = '';
      this.carPay.backAmount = ''; //
      this.carPay.backAmount = '';
      this.$nextTick(() => {
        this.$refs.carPay.clearValidate();
      });
    },
    resetCarPay() {
      //重置表单内容
      this.carPay2.ruleList = [];
      this.carPay2.preferentName = '';
      this.carPay.startTime = '';
      this.carPay.ruleId = '';
      this.carPay.ruleName = '';
      this.carPay.roomId = '';
      this.carPay.roomName = '';
      this.carPay.cycleNum = '';
      this.carPay.calAmount = '';
      this.carPay.shouldAmount = '';
      this.carPay.carNo = '';
      this.carPay.backAmount = ''; //
      this.carPay.backAmount = '';
      this.$nextTick(() => {
        this.$refs.carPay.clearValidate();
      });
    },
    //选择停车场
    selectCarPayPark(val) {
      this.resetCarPay();
      this.queryCarPayMonthCarNo_();
      let item = this.carPay2.parkList.filter((item) => item.communityId === val)[0];
      this.carPay2.feeName = item.communityName + '停车费';
      if (this.carPay.carNo) {
        this.queryCarPayBackAmount();
      }
    },
    //选择车牌号
    selectCarPayCarNo(item) {
      this.resetCarPay();
      this.carPay.carNo = item.carNo;
      if (this.carPay.communityId) {
        this.queryCarPayBackAmount();
      }
    },
    //输入框失去焦点自动拉取数据
    selectCarPayCarNo_Blur(item) {
      // console.log("selectCarPayCarNo_Blur====>"+JSON.stringify(item));
      // if(item){
      //   this.resetCarPay();
      //   this.carPay.carNo = item.carNo;
      // }
      if (this.carPay.communityId) {
        this.queryCarPayBackAmount();
      }
    },
    //补缴方式切换自动拉取数据
    selectCarPayCarNoRadioChange(item) {
      // console.log("selectCarPayCarNo_Blur====>"+JSON.stringify(item));
      // if(item){
      //   this.resetCarPay();
      //   this.carPay.carNo = item.carNo;
      // }
      if (this.carPay.communityId) {
        this.queryCarPayBackAmount();
      }
    },
    //查询停车场
    queryCarPayPark(qs) {
      return loadCarPayPark({ roomId: this.zhxx.roomId, searchContent: qs }).then(({ data }) => {
        this.carPay2.parkList = data;
      });
    },

    queryCarPayMonthCarNo_() {
      loadCarPayMonthCarNo({ communityId: this.carPay.communityId }).then(({ data }) => {
        if (this.vdui.isEmpty(data)) {
          this.$message.info('未查询到车辆信息');
        } else {
          this._.forEach(data, (item) => {
            item.value = item.carNo;
            item.label = item.carNo;
          });
          this.carNoList = data;
        }
      });
    },
    //查询车牌号
    queryCarPayMonthCarNo(qs, cb) {
      loadCarPayMonthCarNo({ communityId: this.carPay.communityId, searchContent: qs }).then(
        ({ data }) => {
          if (this.vdui.isEmpty(data)) {
            cb();
            this.$message.info('未查询到车辆信息');
          } else {
            this._.forEach(data, (item) => {
              item.value = item.carNo;
            });
            cb(data);
          }
        }
      );
    },
    //查询欠费
    queryCarPayBackAmount() {
      loadCarPayBackAmount({
        communityId: this.carPay.communityId,
        carNo: this.carPay.carNo,
      }).then(({ data }) => {
        this.carPay.backAmount = Number(data.carPayBackAmount);
      });
    },
    //查询欠费明细
    queryCarPayBill() {
      loadCarPayBill({
        communityId: this.carPay.communityId,
        carNo: this.carPay.carNo,
      }).then(({ data }) => {
        this.carPay2.billList = data;
      });
    },
    //查询月卡车开始时间
    queryCarPayMonthCarStartTime() {
      loadCarPayMonthCarStartTime({
        communityId: this.carPay.communityId,
        carNo: this.carPay.carNo,
        backType: this.carPay.backType,
        backAmount: this.carPay.backAmount,
      }).then(({ data }) => {
        this.carPay.startTime = data.startTime;
        this.carPay2.preferentName = data.derateName;
        this.carPay2.couponFlag = data.couponFlag;
        this.carPay2.ruleList = data.carMonthChargeRules;
        this.carPay.ruleId =
          data.carMonthChargeRules.length > 0 ? data.carMonthChargeRules[0].id : '';
        this.carPay.ruleName =
          data.carMonthChargeRules.length > 0 ? data.carMonthChargeRules[0].remark : '';
      });
    },

    //查询月卡车开始时间
    queryCarPayMonthCarStartTime_() {
      let self = this;
      loadCarPayMonthCarStartTime({
        communityId: this.carPay.communityId,
        carNo: this.carPay.carNo,
        backType: this.carPay.backType,
        backAmount: this.carPay.backAmount,
      }).then(({ data }) => {
        this.carPay.startTime = data.startTime;
        this.carPay2.preferentName = data.derateName;
        this.carPay2.couponFlag = data.couponFlag;
        this.carPay2.ruleList = data.carMonthChargeRules;
        this.carPay.ruleId =
          data.carMonthChargeRules.length > 0 ? data.carMonthChargeRules[0].id : '';
        this.carPay.ruleName =
          data.carMonthChargeRules.length > 0 ? data.carMonthChargeRules[0].remark : '';
        self.selectCarPayCarNoRadioChange();
      });
    },
    //查询费用总额
    queryCarPayAmount() {
      let arr = this._.compact([
        this.carPay.ruleId,
        this.carPay.cycleNum,
        this.carPay.startTime,
        this.carPay.backType,
      ]);
      if (arr.length === 4) {
        loadCarPayAmount(
          {
            ruleId: this.carPay.ruleId,
            cycleNum: this.carPay.cycleNum,
            startTime: this.carPay.startTime,
            backAmount: this.carPay.backAmount,
            backType: this.carPay.backType,
            couponAmount: this.carPay.couponAmount,
          },
          { showLoading: { text: '查询中' } }
        ).then(({ data }) => {
          this.carPay.calAmount = data.calAmount;
          this.carPay.couponAmount = data.couponAmount;
          this.carPay.shouldAmount = data.shouldAmount;
          this.carPay.billcycleNo = data.billcycleNo;
          this.carPay.propertyId = data.propertyId;
          this.carPay2.endTime = data.endTime;

          this.carPay.roomId = data.roomId;
          this.carPay.roomName = data.roomName;
        });
      }
    },
    //选中
    confirmCarPay() {
      this.payInfo = Object.assign({}, this.payInfo, { authCode: '' });
      this.$refs.carPay.validate((valid) => {
        if (valid) {
          this.selected.carPay = true;
          this.payInfo2.payDetailList.push({
            feeType: 'carPay',
            feeName: this.carPay2.feeName,
            feePeriod: this.carPay.startTime + ' - ' + this.carPay2.endTime,
            calAmount: this.carPay.calAmount + '',
            derateAmount: this.carPay.derateAmount + '',
            couponAmount: this.carPay.couponAmount + '',
            shouldAmount: this.carPay.shouldAmount + '',
          });
        }
      });
    },
    //取消
    cancelCarPay() {
      this.payInfo = Object.assign({}, this.payInfo, { authCode: '' });
      this.selected.carPay = false;
      this.payInfo2.payDetailList = this.payInfo2.payDetailList.filter(
        (item) => item.feeType !== 'carPay'
      );
    },
  },
};
//临时收费
const lssfMix = {
  data() {
    return {
      temporaryPay: {
        itemsetId: '',
        feeSort: '',
        defItemset: '',
        startDate: '',
        endDate: '',
        reason: '',
        calAmount: '',
        derateAmount: '',
        couponAmount: '',
        shouldAmount: '',
        payAmount: '',
        itemsetPreferentList: [],
      },
      temporaryPayRules: {
        itemsetId: [{ required: true, message: '请输入费项', trigger: 'change' }],
        defItemset: [{ required: true, message: '请输入费项', trigger: 'change' }],
        calAmount: [
          { required: true, message: '请输入费用金额', trigger: 'change' },
          { pattern: /^([0-9]+(\.[0-9]{1,2})?)$/, message: '格式有误', trigger: 'change' },
        ],
        couponAmount: [
          { pattern: /^([0-9]+(\.[0-9]{1,2})?)$/, message: '格式有误', trigger: 'change' },
          { validator: this.validateTemporaryPayCouponAmount, trigger: 'change' },
        ],
      },
      temporaryPay2: {
        itemList: [],
        dateRange: '',
        sortType: '',
        accountFlag: 0,
        couponFlag: 0,
        feeName: '',
      },
    };
  },
  watch: {
    //监听临时收费-总额
    'temporaryPay.calAmount': _.debounce(function () {
      if (
        this.vdui.isNotEmpty(this.temporaryPay.calAmount) &&
        /^([0-9]+(\.[0-9]{1,2})?)$/.test(this.temporaryPay.calAmount)
      ) {
        this.queryTemporaryPayAmount();
      } else {
        this.temporaryPay.derateAmount = '';
        this.temporaryPay.couponAmount = '';
        this.temporaryPay.shouldAmount = '';
      }
    }, 1000),
    //监听临时收费-优惠券折扣
    'temporaryPay.couponAmount': _.debounce(function () {
      if (this.vdui.isNotEmpty(this.temporaryPay.calAmount)) {
        let shouldAmount = NP.strip(
          this.temporaryPay.calAmount -
            this.temporaryPay.derateAmount -
            this.temporaryPay.couponAmount
        );
        this.temporaryPay.shouldAmount = shouldAmount < 0 ? '' : shouldAmount;
      }
    }, 1000),
    //监听日期范围
    'temporaryPay2.dateRange'(val) {
      if (this.vdui.isNotEmpty(val)) {
        this.temporaryPay.startDate = val[0] + ' 00:00:00';
        this.temporaryPay.endDate = val[1] + ' 23:59:59';
      }
    },
  },
  methods: {
    //校验抵扣额
    validateTemporaryPayCouponAmount(rule, value, callback) {
      if (this.vdui.isEmpty(value) || value === 0) {
        callback();
      } else if (value < this.temporaryPay.calAmount - this.temporaryPay.derateAmount) {
        callback();
      } else {
        callback(new Error('抵扣已超额'));
      }
    },
    //选择费项
    selectTemporaryPayItem(val) {
      if (this.temporaryPay2.itemList.length > 0) {
        let item = this.temporaryPay2.itemList.filter((item) => item.itemsetId === val)[0];
        this.temporaryPay.feeSort = item.feeSort;
        this.temporaryPay2.sortType = item.sortType;
        this.temporaryPay2.feeName = item.feeItemName;
      } else {
        return;
      }
    },
    //查询费项
    queryTemporaryPayItem() {
      return loadTemporaryPayItem({ roomId: this.zhxx.roomId }).then(({ data }) => {
        this.temporaryPay2.itemList = data;
      });
    },
    //查询临时收费金额
    queryTemporaryPayAmount() {
      loadTemporaryPayAmount(
        {
          roomId: this.zhxx.roomId,
          calAmount: this.temporaryPay.calAmount,
          itemsetId: this.temporaryPay.itemsetId,
        },
        { showLoading: { text: '查询中' } }
      ).then(({ data }) => {
        // this.temporaryPay.calAmount = data.calAmount;
        this.temporaryPay.derateAmount = data.derateAmount;
        this.temporaryPay.couponAmount = data.couponAmount;
        this.temporaryPay.shouldAmount = data.shouldAmount;
        this.temporaryPay.itemsetPreferentList = data.itemsetPreferentList;
        this.temporaryPay2.accountFlag = data.accountFlag;
        this.temporaryPay2.couponFlag = data.couponFlag;
      });
    },
    //选中
    confirmTemporaryPay() {
      this.payInfo = Object.assign({}, this.payInfo, { authCode: '' });
      this.$refs.temporaryPay.validate((valid) => {
        if (valid) {
          this.selected.temporaryPay = true;
          this.temporaryPay.calAmount = this._.toNumber(this.temporaryPay.calAmount);
          this.temporaryPay.couponAmount = this._.toNumber(this.temporaryPay.couponAmount);
          this.payInfo2.payDetailList.push({
            feeType: 'temporaryPay',
            feeName: this.temporaryPay2.feeName,
            feePeriod: this.temporaryPay.startDate
              ? this.temporaryPay.startDate + ' - ' + this.temporaryPay.endDate
              : '',
            calAmount: this.temporaryPay.calAmount + '',
            derateAmount: this.temporaryPay.derateAmount + '',
            couponAmount: this.temporaryPay.couponAmount + '',
            shouldAmount: this.temporaryPay.shouldAmount + '',
          });
        }
      });
    },
    //取消
    cancelTemporaryPay() {
      this.payInfo = Object.assign({}, this.payInfo, { authCode: '' });
      this.selected.temporaryPay = false;
      this.payInfo2.payDetailList = this.payInfo2.payDetailList.filter(
        (item) => item.feeType !== 'temporaryPay'
      );
    },
  },
};
//优惠政策
const yhzcMix = {
  data() {
    return {
      yhzc: {
        list: [],
      },
    };
  },
  methods: {
    //查询优惠政策
    queryYhzc() {
      loadYhzc({ roomId: this.zhxx.roomId }).then(({ data }) => {
        this.yhzc.list = data;
      });
    },
  },
};
//积分余额
const jfyeMix = {
  data() {
    return {
      jfye: {
        householdId: '',
        householdName: '',
        accountAmount: '',
        pointsNumber: 0,
        preferentName: '',
        exchangeId: '',
        exchangePoints: '',
        exchangeAmount: '',
        accounts: [],
        preferents: [],
      },
      jfyeRules: {
        householdId: [{ required: true, message: '请选择住户', trigger: 'change' }],
        exchangeId: [{ required: true, message: '请选择兑换账号', trigger: 'change' }],
        exchangePoints: [
          { required: true, message: '请输入要兑换的积分', trigger: 'change' },
          { pattern: /^[0-9]*[1-9][0-9]*$/, message: '请输入正整数', trigger: 'change' },
          { validator: this.validateExchangePoints, trigger: 'change' },
        ],
      },
    };
  },
  computed: {
    jfyeCP() {
      let exchangeAmount = '';
      if (this.vdui.isNotEmpty(this.jfye.exchangePoints)) {
        if (parseInt(this.jfye.exchangePoints) % this.jfye.preferents[0].paycycleNum === 0) {
          exchangeAmount =
            (parseInt(this.jfye.exchangePoints) / this.jfye.preferents[0].paycycleNum) *
            this.jfye.preferents[0].preferentScore;
        }
      }
      return {
        //兑换金额
        exchangeAmount: exchangeAmount,
      };
    },
  },
  methods: {
    selectHouseHold(val) {
      let account = this._.find(this.jfye.accounts, { householdId: val });
      this.jfye.accountAmount = account.accountAmount;
      this.jfye.pointsNumber = account.pointsNumber;
    },
    //校验积分
    validateExchangePoints(rule, value, callback) {
      if (parseInt(value) > this.jfye.pointsNumber) {
        callback(new Error('不能超过当前积分'));
      } else if (parseInt(value) % this.jfye.preferents[0].paycycleNum !== 0) {
        callback(new Error('必须为' + this.jfye.preferents[0].paycycleNum + '的整数倍'));
      } else {
        callback();
      }
    },
    //查询积分余额
    queryJfye() {
      loadJfye({ roomId: this.zhxx.roomId }).then(({ data }) => {
        this.jfye.accounts = data.accounts;
        this.jfye.preferents = data.preferents;
        this.jfye.preferentName = data.preferentName;
        if (this.vdui.isEmpty(this.jfye.householdId)) {
          this.jfye.householdId = (data.accounts[0] || {}).householdId;
          this.jfye.accountAmount = (data.accounts[0] || {}).accountAmount;
          this.jfye.pointsNumber = (data.accounts[0] || {}).pointsNumber;
        } else {
          let account = this._.find(this.jfye.accounts, { householdId: this.jfye.householdId });
          this.jfye.accountAmount = account.accountAmount;
          this.jfye.pointsNumber = account.pointsNumber;
        }
      });
    },
    //兑换积分
    exchangePoints() {
      this.$refs.jfye.validate((valid) => {
        if (valid) {
          updateJfye(
            {
              householdId: this.jfye.householdId,
              exchangeId: this.jfye.exchangeId,
              exchangePoints: this.jfye.exchangePoints,
              exchangeAmount: this.jfyeCP.exchangeAmount,
            },
            { showLoading: { text: '兑换中' } }
          ).then(({ msg }) => {
            this.$message.success(msg);
            this.queryJfye();
            this.queryAccountAmount();
          });
        }
      });
    },
    //查询缴费人员id和缴费账户余额
    queryAccountAmount() {
      loadAccountAmount({ roomId: this.zhxx.roomId }).then(({ data }) => {
        this.payManId = data.payManId;
        this.payInfo.accountAmount = data.accountAmount || 0;
      });
    },
  },
};

//收费信息
const sfxxMix = {
  data() {
    return {
      payManId: '',
      payInfo: {
        billTotalAmount: 0,
        preTotalAmount: 0,
        carTotalAmount: 0,
        temporaryTotalAmount: 0,
        totalShouldAmount: 0,
        accountAmount: 0,
        totalAccountpayAmount: 0,
        totalPayAmount: 0,
        payType: 7,
        paylabel: '农业银行',
        payBillNo: '',
        payDetail: '',
        payRemark: '',
        authCode: '',
      },
      payInfoRules: {
        totalAccountpayAmount: [
          { pattern: /^[0-9]*[0-9][0-9]*$/, message: '请输入自然数', trigger: 'change' },
          { validator: this.validateTotalAccountpayAmount, trigger: 'change' },
        ],
        totalPayAmount: [
          { required: true, message: '请填写收费金额', trigger: 'change' },
          // { pattern: /^([0-9]+(\.[0-9]{1,2})?)$/, message: '格式有误', trigger: 'change' },
        ],
      },
      payInfo2: {
        payDetailList: [],
        showQrCode: false,
        countdown: 120,
        timer: '',
        tradeStatus: 0,
      },
      isSuccess: false,
    };
  },
  computed: {
    billTotalAmountCP() {
      return this.selected.billPay ? Number(this.billPay.sumOfAmount) : 0;
    },
    preTotalAmountCP() {
      return this.selected.prePay ? Number(this.prePay.shouldAmount) : 0;
    },
    carTotalAmountCP() {
      return this.selected.carPay ? Number(this.carPay.shouldAmount) : 0;
    },
    temporaryTotalAmountCP() {
      return this.selected.temporaryPay ? Number(this.temporaryPay.shouldAmount) : 0;
    },
    totalShouldAmountCP() {
      return (
        this.billTotalAmountCP +
        this.preTotalAmountCP +
        this.carTotalAmountCP +
        this.temporaryTotalAmountCP
      );
    },
  },
  watch: {
    //监听应收总额
    totalShouldAmountCP(val) {
      this.payInfo.totalAccountpayAmount = val;
      this.calculatePayInfoAmount();
    },
    //监听账户余额
    'payInfo.accountAmount'(val) {
      this.calculatePayInfoAmount();
    },
    //监听账户折扣
    'payInfo.totalAccountpayAmount'(val) {
      this.payInfo.totalPayAmount = NP.strip(
        this.totalShouldAmountCP - this.payInfo.totalAccountpayAmount
      );
    },
  },
  methods: {
    changeValue(e) {
      this.dict.forEach((item) => {
        if (item.dictValue == e) {
          this.payInfo.payType = parseInt(item.dictKey);
        }
      });
      // console.log(
      //       this.isSuccess ||
      //       this.totalShouldAmountCP === 0 ||
      //       (this.payInfo.payType !== 2 && this.payInfo.payType !== 3));

      // console.log(this.isSuccess);
      // console.log(this.totalShouldAmountCP);
      // console.log(this.totalShouldAmountCP === 0);
      // console.log(this.payInfo.payType);
      // console.log(this.payInfo.payType != 2 && this.payInfo.payType != 3);
    },
    //校验抵扣金额
    validateTotalAccountpayAmount(rule, value, callback) {
      if (this.totalShouldAmountCP <= this.payInfo.accountAmount) {
        if (parseInt(value) > this.totalShouldAmountCP) {
          callback(new Error('不能超过应收总额'));
        }
      } else {
        if (parseInt(value) > this.payInfo.accountAmount) {
          callback(new Error('不能超过账户余额'));
        }
      }
      callback();
    },
    //计算收费金额
    calculatePayInfoAmount() {
      if (this.totalShouldAmountCP <= this.payInfo.accountAmount) {
        this.payInfo.totalAccountpayAmount = this.totalShouldAmountCP;
        this.payInfo.totalPayAmount = 0;
      } else {
        this.payInfo.totalAccountpayAmount = this.payInfo.accountAmount;
        this.payInfo.totalPayAmount = NP.strip(
          this.totalShouldAmountCP - this.payInfo.totalAccountpayAmount
        );
      }
    },
    //生成二维码
    genearateQrCode() {
      console.log('123 generateQrCode==>', 123);
      this.$refs.payInfo.validate((valid) => {
        if (valid) {
          if (this.isRepeatBill) {
            this.$message.error(`${this.isRepeatBill}账单已在账单收费中被选中，请取消后再进行操作`);
            return;
          }
          //debugger;
          //console.log(this.payParams);
          saveQrCodePay(this.payParams, { showLoading: { text: '正在获取二维码' } }).then(
            ({ data }) => {
              this.payInfo2.showQrCode = true;
              this.payInfo.payBillNo = data.payBillNo;
              this.$nextTick(() => {
                new QRCode('qrcode', {
                  width: 250,
                  height: 250,
                  text: data.codeUrl,
                });
              });
              this.payInfo2.showQrCode = true;
              this.payInfo2.countdown = 120;
              this.payInfo2.timer = setInterval(() => {
                if (this.payInfo2.countdown === 0) {
                  clearInterval(this.payInfo2.timer);
                  this.payInfo2.showQrCode = false;
                  this.$message.info('倒计时结束，二维码弹窗关闭');
                }
                if (this.payInfo2.countdown % 5 === 0) {
                  loadPayStatus({ payBillNo: this.payInfo.payBillNo }).then(({ data }) => {
                    this.payInfo2.tradeStatus = data.tradeStatus;
                    if (data.tradeStatus === 2) {
                      this.payInfo2.showQrCode = false;
                      this.$message.success('支付成功');
                      this.isSuccess = true;
                      clearInterval(this.payInfo2.timer);
                      //重置数据
                      this.resetAllData();
                      // this.submitAllBill();
                    }
                  });
                }
                this.payInfo2.countdown--;
              }, 1000);
            }
          );
        }
      });
    },
    //关闭二维码
    closeQrCode() {
      setTimeout(() => {
        this.$refs.qrcode.innerHTML = '';
      }, 300);
      clearInterval(this.payInfo2.timer);
      if(this.payInfo2.tradeStatus === 2){
        console.log('success');
      }else{
        window.location.reload();
      }
    },
  },
};

export default {
  name: 'property-charge',
  mixins: [zhxxMix, zdsfMix, ysfMix, clsfMix, lssfMix, yhzcMix, jfyeMix, sfxxMix],
  data() {
    return {
      bankBillStatusList: [],
      activeTab: '1',
      dict: [],
      selected: {
        billPay: false,
        prePay: false,
        carPay: false,
        temporaryPay: false,
      },
      statusDialogVisible: false,
      statusDuration: 120,
    };
  },
  created() {
    this.getPayType();
    this.getBankBillStatus();
  },
  computed: {
    ...mapGetters(['permission']),
    permissions() {
      return {
        propertyAmountCheck: this.vaildData(
          this.permission.propertyCharge_propertyAmountCheck,
          false
        ),
        otherAmountCheck: this.vaildData(this.permission.propertyCharge_otherAmountCheck, false),
        proxyAmountCheck: this.vaildData(this.permission.propertyCharge_proxyAmountCheck, false),
        byMonthCar: this.vaildData(this.permission.propertyCharge_byMonthCar, false),
        byTempCar: this.vaildData(this.permission.propertyCharge_byTempCar, false),
        byNoSubsidy: this.vaildData(this.permission.propertyCharge_byNoSubsidy, false),
      };
    },
    //统一操作控制
    disabledCtrl() {
      return this.vdui.isEmpty(this.zhxx.roomId);
    },
    payParams() {
      let params = this._.merge(
        {
          roomId: this.zhxx.roomId,
          roomName: this.zhxx.roomName,
          payManId: this.payManId,
          payInfo: this.payInfo,
          householdName: this.zhxx.householder,
        },
        {
          payInfo: {
            billTotalAmount: this.billTotalAmountCP,
            preTotalAmount: this.preTotalAmountCP,
            carTotalAmount: this.carTotalAmountCP,
            temporaryTotalAmount: this.temporaryTotalAmountCP,
            totalShouldAmount: this.totalShouldAmountCP,
            payDetail: JSON.stringify(this.payInfo2.payDetailList),
          },
        }
      );
      if (this.selected.billPay) {
        params.billPay = this.billPay;
      }
      if (this.selected.prePay) {
        params.prePay = this.prePay;
      }
      if (this.selected.carPay) {
        params.carPay = this.carPay;
        //fix 如果未选择 住房 直接选择 车辆收费,后台需要 roomId,roomName从carPay中取. 20200605 pengyichao
        if (params.roomId == '' || params.roomName == '') {
          params.roomId = params.carPay.roomId;
          params.roomName = params.carPay.roomName;
        }
        //fix end
      }
      if (this.selected.temporaryPay) {
        params.temporaryPay = this.temporaryPay;
      }
      return params;
    },
    //判断账单与预收费是否重叠
    isRepeatBill() {
      let flag = false;
      if (this.selected.billPay && this.selected.prePay) {
        let prePayBillcycleNo = this.prePay.billcycleNo;
        let preItemsetId = this.prePay.itemsetId;
        this._.forEach(this.billPay.feeBillList, (item) => {
          if (prePayBillcycleNo === item.billcycleNo && preItemsetId === item.billItemsetId) {
            flag = prePayBillcycleNo;
            return false;
          }
        });
      }
      return flag;
    },
  },
  mounted() {
    this.queryCarPayPark('');
  },
  methods: {
    getLockFlagStatus(lockFlag) {
      // if(parseInt(lockFlag)==0){
      //   return '未锁定';
      // }
      // if(parseInt(lockFlag)==1){
      //   return '划扣中';
      // }
      let lockFlagLabel = '';
      this.bankBillStatusList.forEach((v, i) => {
        if (parseInt(v.dictKey) == lockFlag) {
          lockFlagLabel = v.dictValue;
        }
      });
      return lockFlagLabel;
    },

    getBankBillStatus() {
      bankBillStatus().then((res) => {
        this.bankBillStatusList = res.data;
        console.log(res);
      });
    },

    //重置所有数据:支付完成后调用;但是不清除收费信息;收费信息用于打印
    resetAllData() {
      //放开按钮
      this.cancelBillPay();
      this.cancelPrePay();
      this.cancelTemporaryPay();
      this.cancelCarPay();
      this.isSuccess = false;
      //重置车辆收费数据
      this.resetCarPay();
      //重置zhxx的数据
      this.zhxx = {
        communityGroup:'',
        shortCode: '',
        roomId: '',
        roomName: '',
        roomLayout: '',
        roomLayoutName: '',
        roomType: '',
        roomTypeName: '',
        roomStatus: '',
        roomStatusName: '',
        floorage: '',
        usableArea: '',
        roomOrientations: '',
        roomOrientationsName: '',
        useFlag: '',
        additionAreaFlag: 0,
        parkingAreaFlag: 0,
        loftAreaFlag: 0,
        householder: '',
        householderPhone: '',
        leaseholder: '',
        leaseholderPhone: '',
        carNo1: '',
        carStatus1: 0,
        carNo2: '',
        carStatus2: 1,
      };
      this.qfxx = {
        totalAmount: 0,
        propertyAmount: 0,
        temporaryStopAmount: 0,
        otherAmount: 0,
        proxyAmount: 0,
      };
      //账单收费重置
      this.temporaryPay = {
        itemsetId: '',
        feeSort: '',
        defItemset: '',
        startDate: '',
        endDate: '',
        reason: '',
        calAmount: '',
        derateAmount: '',
        couponAmount: '',
        shouldAmount: '',
        payAmount: '',
        itemsetPreferentList: [],
      };

      //预收费重置
      this.prePay = {
        itemsetId: '',
        feeSort: '',
        payUse: 1,
        billcycleNo: '',
        cycleNum: '',
        billStartDate: '',
        billEndDate: '',
        calAmount: '',
        derateAmount: '',
        couponAmount: '',
        shouldAmount: '',
        payAmount: '',
        itemsetPreferentList: [],
      };
      this.billPay2 = {
        itemList: [],
        billStartDateList: [],
        preferentName: '',
        accountFlag: 0,
        couponFlag: 0,
        feeName: '',
        propertyAmountCheck: 1,
        otherAmountCheck: 1,
        proxyAmountCheck: 1,
        list: [],
      };
      //清楚表单校验;备注:账单收费没有校验??
      this.$refs.prePay.clearValidate();
      this.$refs.carPay.clearValidate();
      this.$refs.temporaryPay.clearValidate();
    },
    //   获取支付方式字典
    getPayType() {
      payType().then((res) => {
        let temArr = [];
        res.data.forEach(ele=>{
          if(ele.dictKey!=7){
            temArr.push(ele);
          }else{
            temArr.unshift(ele);
          }
        })
        this.dict = temArr;
        this.payInfo.payType = this.dict[0]?parseInt(this.dict[0].dictKey):'';
        this.payInfo.paylabel = this.dict[0]?this.dict[0].dictValue:'';
        console.log(res);
      });
    },
    //收款
    makeCollections() {
      this.$refs.payInfo.validate((valid) => {
        if (valid) {
          if (this.isRepeatBill) {
            this.$message.error(
              `${this.isRepeatBill} 账单已在账单收费中被选中，请取消后再进行操作`
            );
            return;
          }
          if (this.payInfo.payType === 1 || this.payInfo.payType === 8) {
            this.submitAllBill();
          } else {
            this.payByBarCode();
          }
        }
      });
    },
    //条码支付
    payByBarCode() {
      if (this.isRepeatBill) {
        this.$message.error(`${this.isRepeatBill}账单已在账单收费中被选中，请取消后再进行操作`);
        return;
      }
      saveBarCodePay(this.payParams, { showLoading: { text: '收款中' } }).then(({ data }) => {
        this.payInfo.payBillNo = data.payBillNo;
        this.isSuccess = true;
        this.payInfo = Object.assign({}, this.payInfo, { authCode: '' });
        console.log('data==>', data);
        // fix:2021-03-19 条码支付轮询支付状态,注:这里必须是字符串 'false'
        if (data.payBillNo && data.isSuccess == 'false') {
          this.openMaskAndPollingPayStatus();
        }else{
          this.payInfo2.tradeStatus = 2;
        }
        // fix end
        // this.submitAllBill();
        //清楚数据
        this.resetAllData();
      });
    },
    //保存账单
    submitAllBill() {
      saveAllBill(this.payParams, { showLoading: { text: '处理中' } }).then(({ data, msg }) => {
        this.payInfo.payBillNo = data.payBillNo;
        this.isSuccess = data.isSuccess;
        this.$message.success(msg);
        this.payInfo = Object.assign({}, this.payInfo, { authCode: '' });
        //清楚数据
        this.resetAllData();
      });
    },
    //打印预览
    printprev() {
      if (
        this.payInfo.payBillNo != ''
        &&(this.payInfo2.tradeStatus === 2 || this.payInfo.payType === 1 || this.payInfo.payType === 8)
      ) {
        this.$refs.printPreview.openPayChargePrintPreDialog(this.payInfo.payBillNo);
      } else {
        this.$message.warning('请先完成收款');
      }
    },
    test() {
      console.log('123==>', 123);
      // this.openMaskAndPollingPayStatus();
    },
    //
    openMaskAndPollingPayStatus() {
      this.statusDialogVisible = true;
      let timer = setInterval(() => {
        console.log('this.status==>', this.statusDuration);
        this.statusDuration--;
        console.log('this.status==>', typeof this.statusDuration);
        if (this.statusDuration <= 0) {
          this.$message.error('支付失败');
          this.statusDialogVisible = false;
          clearInterval(timer);
          this.statusDuration = 120;
          window.location.reload();
        } else {
          if (this.statusDuration % 10 == 0 || this.statusDuration == 119) {
            loadPayStatus({ payBillNo: this.payInfo.payBillNo }).then(({ data }) => {
              console.log('res pooling  data==>', data);
              if (data.tradeStatus === 2) {
                this.payInfo2.tradeStatus = data.tradeStatus;
                this.$message.success('支付成功');
                this.statusDialogVisible = false;
                clearInterval(timer);
                this.statusDuration = 120
              }
            });
          }
        }
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-weight: bold;
}
.pay-type {
  float: left;
  width: calc(100% - 33px);
}
.pay-qrcode {
  float: left;
  min-width: 0;
  padding: 0;
  font-size: 24px;
}
</style>
<style lang="scss">
.property-charge {
  .el-input .el-input__inner {
    color: #000000;
  }
  .el-date-editor.el-input {
    width: 100%;
  }
  .el-radio {
    margin-right: 8px;
  }
  .el-radio__label {
    padding-left: 0;
  }

  .el-divider--horizontal {
    margin-top: 8px;
  }
  .danger {
    color: #f56c6c;
    .el-input__inner {
      color: #f56c6c;
    }
  }
  .warning {
    color: #e6a23c;
    .el-input__inner {
      color: #e6a23c;
    }
  }
  .bill-table2 {
    width: 100%;
    height: 100%;
    border: 1px solid #dcdfe6;
    &.el-table--small td {
      padding: 2px 0;
    }
    &.el-table .cell {
      line-height: 20px;
    }
  }
}
.el-dialog.room-select-dialog {
  .el-dialog__body {
    padding-top: 8px;
    padding-bottom: 8px;
  }
}
</style>
